/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
	Activities = "activities",
	ActivityChecklist = "activity_checklist",
	DailySummary = "daily_summary",
	DailySummaryCategoryDefinition = "daily_summary_category_definition",
	DailySummaryCategorySentiment = "daily_summary_category_sentiment",
	DailySummaryCategorySentimentDefinition = "daily_summary_category_sentiment_definition",
	Diaper = "diaper",
	DiaperStatus = "diaper_status",
	FamilyAlbum = "family_album",
	FamilyAlbumMember = "family_album_member",
	FamilyAlbumUpload = "family_album_upload",
	Feeding = "feeding",
	KidActivities = "kid_activities",
	KidActivityTypes = "kid_activity_types",
	Kids = "kids",
	MomentsDailyEntry = "moments_daily_entry",
	MomentsUploads = "moments_uploads",
	ParentMoods = "parent_moods",
	Sleep = "sleep",
	Users = "users",
}

// Alias types for improved usability
export type IsoDateString = string
export type RecordIdString = string
export type HTMLString = string

// System fields
export type BaseSystemFields<T = never> = {
	id: RecordIdString
	created: IsoDateString
	updated: IsoDateString
	collectionId: string
	collectionName: Collections
	expand?: T
}

export type AuthSystemFields<T = never> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export enum ActivitiesKindOptions {
	"diaper" = "diaper",
	"feed" = "feed",
	"parent_mood" = "parent_mood",
	"sleep" = "sleep",
}
export type ActivitiesRecord<Tjson = unknown> = {
	date: IsoDateString
	json: null | Tjson
	kid: RecordIdString
	kind: ActivitiesKindOptions
}

export enum ActivityChecklistStatusOptions {
	"open" = "open",
	"completed" = "completed",
}
export type ActivityChecklistRecord = {
	added: IsoDateString
	completed_at?: IsoDateString
	completed_by?: RecordIdString
	creator: RecordIdString
	diaper?: RecordIdString
	feeding?: RecordIdString
	kid: RecordIdString
	notes?: HTMLString
	sleep?: RecordIdString
	status: ActivityChecklistStatusOptions
}

export type DailySummaryRecord = {
	created_by_parent: RecordIdString
	date: IsoDateString
	kid: RecordIdString
	notes?: string
}

export enum DailySummaryCategoryDefinitionInputTypeOptions {
	"multichoice" = "multichoice",
	"single" = "single",
}
export type DailySummaryCategoryDefinitionRecord = {
	description?: HTMLString
	display_order?: number
	input_type: DailySummaryCategoryDefinitionInputTypeOptions
	name: string
}

export type DailySummaryCategorySentimentRecord = {
	daily_summary: RecordIdString
	sentiment_definition: RecordIdString
	value?: number
}

export type DailySummaryCategorySentimentDefinitionRecord = {
	daily_summary_category: RecordIdString
	name: string
	value?: number
}

export type DiaperRecord = {
	date: IsoDateString
	kid: RecordIdString
	notes?: HTMLString
	status: RecordIdString
}

export type DiaperStatusRecord = {
	order?: number
	short_name?: string
	status?: string
}

export type FamilyAlbumRecord = {
	name?: string
	slug: string
}

export type FamilyAlbumMemberRecord = {
	album: RecordIdString
	member: RecordIdString
	relationship: string
}

export type FamilyAlbumUploadRecord = {
	album: RecordIdString
	image: string
	notes?: HTMLString
	timestamp: IsoDateString
	uploader: RecordIdString
}

export enum FeedingKindOptions {
	"nursing" = "nursing",
	"expressing" = "expressing",
	"formula" = "formula",
}

export enum FeedingAmountUnitOptions {
	"oz" = "oz",
}
export type FeedingRecord = {
	amount?: number
	amountUnit?: FeedingAmountUnitOptions
	date?: IsoDateString
	kid: RecordIdString
	kind: FeedingKindOptions
	leftBreastUsed?: boolean
	notes?: HTMLString
	rightBreastUsed?: boolean
}

export type KidActivitiesRecord = {
	date?: IsoDateString
	kid: RecordIdString
	kid_activity_type: RecordIdString
	notes?: HTMLString
}

export type KidActivityTypesRecord = {
	hidden?: boolean
	kid: RecordIdString
	name: string
}

export type KidsRecord = {
	avatar?: string
	backdrop?: string
	birthday: IsoDateString
	name: string
	slug: string
}

export type MomentsDailyEntryRecord = {
	date: IsoDateString
	kid: RecordIdString
	notes?: HTMLString
}

export type MomentsUploadsRecord = {
	image: string
	kid: RecordIdString
	moment: RecordIdString
	notes?: HTMLString
	uploader: RecordIdString
}

export type ParentMoodsRecord = {
	kid: RecordIdString
	mood: string
	parent: RecordIdString
}

export type SleepRecord = {
	end?: IsoDateString
	kid: RecordIdString
	notes?: HTMLString
	start: IsoDateString
}

export type UsersRecord = {
	avatar?: string
	name?: string
	parent_of?: RecordIdString[]
}

// Response types include system fields and match responses from the PocketBase API
export type ActivitiesResponse<Tjson = unknown, Texpand = unknown> = Required<ActivitiesRecord<Tjson>> & BaseSystemFields<Texpand>
export type ActivityChecklistResponse<Texpand = unknown> = Required<ActivityChecklistRecord> & BaseSystemFields<Texpand>
export type DailySummaryResponse<Texpand = unknown> = Required<DailySummaryRecord> & BaseSystemFields<Texpand>
export type DailySummaryCategoryDefinitionResponse<Texpand = unknown> = Required<DailySummaryCategoryDefinitionRecord> & BaseSystemFields<Texpand>
export type DailySummaryCategorySentimentResponse<Texpand = unknown> = Required<DailySummaryCategorySentimentRecord> & BaseSystemFields<Texpand>
export type DailySummaryCategorySentimentDefinitionResponse<Texpand = unknown> = Required<DailySummaryCategorySentimentDefinitionRecord> & BaseSystemFields<Texpand>
export type DiaperResponse<Texpand = unknown> = Required<DiaperRecord> & BaseSystemFields<Texpand>
export type DiaperStatusResponse<Texpand = unknown> = Required<DiaperStatusRecord> & BaseSystemFields<Texpand>
export type FamilyAlbumResponse<Texpand = unknown> = Required<FamilyAlbumRecord> & BaseSystemFields<Texpand>
export type FamilyAlbumMemberResponse<Texpand = unknown> = Required<FamilyAlbumMemberRecord> & BaseSystemFields<Texpand>
export type FamilyAlbumUploadResponse<Texpand = unknown> = Required<FamilyAlbumUploadRecord> & BaseSystemFields<Texpand>
export type FeedingResponse<Texpand = unknown> = Required<FeedingRecord> & BaseSystemFields<Texpand>
export type KidActivitiesResponse<Texpand = unknown> = Required<KidActivitiesRecord> & BaseSystemFields<Texpand>
export type KidActivityTypesResponse<Texpand = unknown> = Required<KidActivityTypesRecord> & BaseSystemFields<Texpand>
export type KidsResponse<Texpand = unknown> = Required<KidsRecord> & BaseSystemFields<Texpand>
export type MomentsDailyEntryResponse<Texpand = unknown> = Required<MomentsDailyEntryRecord> & BaseSystemFields<Texpand>
export type MomentsUploadsResponse<Texpand = unknown> = Required<MomentsUploadsRecord> & BaseSystemFields<Texpand>
export type ParentMoodsResponse<Texpand = unknown> = Required<ParentMoodsRecord> & BaseSystemFields<Texpand>
export type SleepResponse<Texpand = unknown> = Required<SleepRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> & AuthSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	activities: ActivitiesRecord
	activity_checklist: ActivityChecklistRecord
	daily_summary: DailySummaryRecord
	daily_summary_category_definition: DailySummaryCategoryDefinitionRecord
	daily_summary_category_sentiment: DailySummaryCategorySentimentRecord
	daily_summary_category_sentiment_definition: DailySummaryCategorySentimentDefinitionRecord
	diaper: DiaperRecord
	diaper_status: DiaperStatusRecord
	family_album: FamilyAlbumRecord
	family_album_member: FamilyAlbumMemberRecord
	family_album_upload: FamilyAlbumUploadRecord
	feeding: FeedingRecord
	kid_activities: KidActivitiesRecord
	kid_activity_types: KidActivityTypesRecord
	kids: KidsRecord
	moments_daily_entry: MomentsDailyEntryRecord
	moments_uploads: MomentsUploadsRecord
	parent_moods: ParentMoodsRecord
	sleep: SleepRecord
	users: UsersRecord
}

export type CollectionResponses = {
	activities: ActivitiesResponse
	activity_checklist: ActivityChecklistResponse
	daily_summary: DailySummaryResponse
	daily_summary_category_definition: DailySummaryCategoryDefinitionResponse
	daily_summary_category_sentiment: DailySummaryCategorySentimentResponse
	daily_summary_category_sentiment_definition: DailySummaryCategorySentimentDefinitionResponse
	diaper: DiaperResponse
	diaper_status: DiaperStatusResponse
	family_album: FamilyAlbumResponse
	family_album_member: FamilyAlbumMemberResponse
	family_album_upload: FamilyAlbumUploadResponse
	feeding: FeedingResponse
	kid_activities: KidActivitiesResponse
	kid_activity_types: KidActivityTypesResponse
	kids: KidsResponse
	moments_daily_entry: MomentsDailyEntryResponse
	moments_uploads: MomentsUploadsResponse
	parent_moods: ParentMoodsResponse
	sleep: SleepResponse
	users: UsersResponse
}

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = PocketBase & {
	collection(idOrName: 'activities'): RecordService<ActivitiesResponse>
	collection(idOrName: 'activity_checklist'): RecordService<ActivityChecklistResponse>
	collection(idOrName: 'daily_summary'): RecordService<DailySummaryResponse>
	collection(idOrName: 'daily_summary_category_definition'): RecordService<DailySummaryCategoryDefinitionResponse>
	collection(idOrName: 'daily_summary_category_sentiment'): RecordService<DailySummaryCategorySentimentResponse>
	collection(idOrName: 'daily_summary_category_sentiment_definition'): RecordService<DailySummaryCategorySentimentDefinitionResponse>
	collection(idOrName: 'diaper'): RecordService<DiaperResponse>
	collection(idOrName: 'diaper_status'): RecordService<DiaperStatusResponse>
	collection(idOrName: 'family_album'): RecordService<FamilyAlbumResponse>
	collection(idOrName: 'family_album_member'): RecordService<FamilyAlbumMemberResponse>
	collection(idOrName: 'family_album_upload'): RecordService<FamilyAlbumUploadResponse>
	collection(idOrName: 'feeding'): RecordService<FeedingResponse>
	collection(idOrName: 'kid_activities'): RecordService<KidActivitiesResponse>
	collection(idOrName: 'kid_activity_types'): RecordService<KidActivityTypesResponse>
	collection(idOrName: 'kids'): RecordService<KidsResponse>
	collection(idOrName: 'moments_daily_entry'): RecordService<MomentsDailyEntryResponse>
	collection(idOrName: 'moments_uploads'): RecordService<MomentsUploadsResponse>
	collection(idOrName: 'parent_moods'): RecordService<ParentMoodsResponse>
	collection(idOrName: 'sleep'): RecordService<SleepResponse>
	collection(idOrName: 'users'): RecordService<UsersResponse>
}
